module.exports = __webpack_public_path__ + "static/img/imgleft.9d696e93.png";